import $ from 'gridstrap/lib/gs-zepto';


export class GSHeaderMenuBar {

	//
	// Properties
	//

	private root;
	private items;
	private tray;
	private hamburger;

	private isOpen;
	private isMobile;
	private scrubTimer;

	//
	// Methods
	//

	private hamburgerMenuClicked(isOpen) {
		this.isMobile = true;
		window.scrollTo({ top: -1, behavior: 'smooth' });
		$('body').toggleClass('gs-HeaderMenu--frozen', isOpen);
		isOpen ? this.tray.open() : this.tray.close();
	}

	// private scrubbed(evt) {
	// 	clearTimeout(this.scrubTimer);
	// 	const item = $(evt.currentTarget);
	// 	const id = item.data('headerMenuBarSectionId');
	// 	this.scrubTimer = setTimeout(() => {
	// 		if (!this.isOpen) this.tray.open(id);
	// 	}, 150);
	// }

	// private hovered(evt) {
	// 	const item = $(evt.currentTarget);
	// 	const id = item.data('headerMenuBarSectionId');
	// 	if (this.isOpen) this.tray.open(id);
	// }

	private opened(id) {
		const item = this.root.find(`[data-header-menu-bar-section-id="${id}"]`);
		this.root.addClass('gs-HeaderMenuBar--open');
		this.items.removeClass('gs-HeaderMenuBar-item--open');
		this.hamburger.markAsOpened();
		item.addClass('gs-HeaderMenuBar-item--open');
		this.isOpen = true;
	}

	private closed() {
		this.root.removeClass('gs-HeaderMenuBar--open');
		this.items.removeClass('gs-HeaderMenuBar-item--open');
		$('body').removeClass('gs-HeaderMenu--frozen')
		this.hamburger.markAsClosed();
		this.isOpen = false;
		this.isMobile = false;
	}

	// private close() {
	// 	clearTimeout(this.scrubTimer);
	// 	this.tray.close();
	// }

	// private reset() {
	// 	clearTimeout(this.scrubTimer);
	// 	this.tray.reset();
	// }

	//
	// Initialization
	//

	constructor(root) {
		this.root = $(root);
		this.items = this.root.find('.gs-HeaderMenuBar-item');
	}

	gsOnInit() {
		this.tray = $('.gs-HeaderMenuTray').gs(0);
		this.hamburger = this.root.find('.gs-HamburgerMenu').gs(0);

		// this.items.on('mouseenter', (evt) => this.hovered(evt));
		// this.items.on('mousemove', (evt) => this.scrubbed(evt));
		// this.root.on('mouseenter', () => !this.isMobile && this.reset());
		// this.root.on('mouseleave', () => !this.isMobile && this.close());

		this.tray.on('open', (id) => this.opened(id));
		this.tray.on('close', () => this.closed());

		this.hamburger.on('click', (menu) => this.hamburgerMenuClicked(menu.isOpen));
	}
}
